/* Different Drips — sticky add-to-cart bar on product pages.
   Appears once the buy buttons scroll out of view; the bar's button
   clicks the real form submit so variant/cart logic stays Dawn's. */
(function () {
  function init() {
    var bar = document.querySelector('.dd-sticky-atc');
    if (!bar || bar.dataset.ddInit) return;
    bar.dataset.ddInit = '1';

    var sectionId = bar.dataset.section;
    var submit = document.getElementById('ProductSubmitButton-' + sectionId);
    var sentinel = document.querySelector('.product-form__buttons') || submit;
    if (!sentinel) return;

    bar.removeAttribute('hidden');
    /* draft previews overlay a bottom bar; lift above it so merchants can see this */
    if (location.hostname.indexOf('shopifypreview.com') !== -1) bar.style.bottom = '6.6rem';

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);

    bar.querySelector('.dd-sticky-atc__btn').addEventListener('click', function () {
      var liveSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
      if (liveSubmit && !liveSubmit.disabled) liveSubmit.click();
    });

    /* keep price in sync after variant changes (Dawn re-renders the price block) */
    document.addEventListener('change', function (e) {
      if (!e.target.closest('variant-selects, .product-form__input')) return;
      setTimeout(function () {
        var sale = document.querySelector('.price--on-sale .price__sale .price-item--sale');
        var regular = document.querySelector('.price__regular .price-item--regular');
        var current = sale || regular;
        var compare = document.querySelector('.price--on-sale .price__sale s.price-item--regular');
        if (current) bar.querySelector('.dd-sticky-atc__price-now').textContent = current.textContent.trim();
        var barCompare = bar.querySelector('.dd-sticky-atc__price s');
        if (barCompare && compare) barCompare.textContent = compare.textContent.trim();
      }, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Recommendations: eager-load fallback when the lazy observer never fires */
(function () {
  function kickRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (rp) {
      if (rp.innerHTML.trim().length) return;
      if (typeof rp.loadRecommendations === 'function' && rp.dataset.productId) {
        rp.loadRecommendations(rp.dataset.productId);
      }
    });
  }
  setTimeout(kickRecommendations, 1500);
  setTimeout(kickRecommendations, 4000);
})();
